import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { ReferenceManyField } from 'react-admin';
import { Alert } from 'shared/mui/Alert/Alert';
import { Card } from 'shared/mui/Card';
import { CardHeader } from 'shared/mui/Card/CardHeader/CardHeader';
import { Stack } from 'shared/mui/Stack/Stack';
import { DateTimeField, WrapperField } from 'shared/react-admin/Fields';
import { Pagination } from 'shared/react-admin/Pagination/Pagination';

import { StyledDatagrid } from './OrdersShowLogs.styled';
import { OrdersShowLogsChangeStatusesField } from './OrdersShowLogsChangeStatusesField/OrdersShowLogsChangeStatusesField';
import { OrdersShowLogsDirectionField } from './OrdersShowLogsDirectionField/OrdersShowLogsDirectionField';
import { OrdersRequestLogsExpand } from './OrdersShowLogsExpand/OrdersShowLogsExpand';
import { OrdersShowLogsResponseFields } from './OrdersShowLogsResponseFields';
import { OrdersShowLogsTypeField } from './OrdersShowLogsTypeField/OrdersShowLogsTypeField';

export const OrdersShowLogs = (): JSX.Element => {
  const t = useTypedTranslate();

  return (
    <Card sx={{ background: 'transparent' }}>
      <CardHeader
        sx={{ padding: '0 0 16px 0' }}
        title={t('app.orders.logs.title')}
        titleSize="smallBold"
      />
      <ReferenceManyField
        label={false}
        pagination={<Pagination />}
        reference="order_events"
        sort={{ field: 'requestAt', order: 'DESC' }}
        target="orderId"
      >
        <StyledDatagrid
          bulkActionButtons={false}
          empty={<Alert severity="info">{t('app.orders.logs.empty')}</Alert>}
          expand={<OrdersRequestLogsExpand />}
        >
          <DateTimeField
            label={t('app.orders.logs.createdAt')}
            source="requestAt"
            timeMask="HH:mm:ss.SSS"
          />
          <OrdersShowLogsDirectionField cellClassName="column-direction" />
          <WrapperField>
            <Stack gap="4px">
              <OrdersShowLogsResponseFields />
              <OrdersShowLogsTypeField />
              <OrdersShowLogsChangeStatusesField />
            </Stack>
          </WrapperField>
        </StyledDatagrid>
      </ReferenceManyField>
    </Card>
  );
};
